<template>
  <ul class="tw-ml-4">
    <li
      v-for="reason in reasonsForDetection"
      :key="reason"
      class="tw-list-disc"
    >
      {{ reason }}
    </li>
  </ul>
</template>
<script setup lang="ts">
defineProps<{ reasonsForDetection: string[] }>();
</script>
